import React from 'react'
import { Button } from '@commutifi-fe/ui'
import { FormattedMessage } from 'locales/index'

interface SSOLoginProps {
  providerName: string
  isLoading?: boolean
  onSubmit?: React.ReactEventHandler
  children?: React.ReactNode
}

export function SSOLogin({ providerName, onSubmit, isLoading, children }: SSOLoginProps) {
  const handleOnSubmit: React.MouseEventHandler = (e) => {
    onSubmit && onSubmit(e)
  }

  return (
    <>
      {children}
      <Button onClick={handleOnSubmit} loading={isLoading} type="primary" block>
        <FormattedMessage id="auth.login.withProvider" values={{ providerName }} />
      </Button>
    </>
  )
}
